<template>
  <div class="search-rlsj">
    <div class="u-p5-x-3">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          卡口数据检索
        </h4>
      </template>
      <car-form
        @submit="submit"
        :showformitem="formItemshow"
        :default-form-value="defaultFormValue"
      ></car-form>
    </div>
    <div style="padding: 0 20px">
      <car-img-list
        v-if="imageList.length > 0"
        @carshow="carimgShow"
        :key="refreshKey"
        :image-list="imageList"
        :showlistitem="['cartime', 'plateNumber']"
      ></car-img-list>
      <div style="text-align: center; color: #b3b3b3; padding: 0.5rem 0" v-show="loading">
        <i style="font-size: 0.38rem;color#FFF" class="el-icon el-icon-loading"></i>
      </div>
      <div
        v-show="imageList.length == 0 && !loading"
        style="text-align: center; color: #b3b3b3; padding: 0.5rem 0"
      >
        查询结果为空
      </div>
    </div>
  </div>
</template>

<script>
import CarForm from "@/components/form/carForm.vue";
import CarImgList from "@/components/carImgList.vue";
export default {
  components: {
    CarForm,
    CarImgList,
  },
  data() {
    const typeTime = {
      beginTime: this.$myPlug.timeFormat(
        //new Date().getTime() - 60000 * 60 * 24 * 1,
        new Date().getTime(),
        "yyyy-mm-dd 00:00:00"
      ),
      endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss"),
    };
    return {
      setTimer: null,
      isEnd: false,
      loading: false,
      defaultFormValue: {
        cartime: Object.values(typeTime),
      },
      form: { ...typeTime },
      pageRow: 12,
      pageIndex: 1,
      refreshKey: "t1",
      formItemshow: [
        "plateNo",
        "plateColor",
        "cameratollgate",
        //"deviceType",
        "cartime",
        "vehicleType",
      ],
      imageList: [],
    };
  },
  methods: {
    submit(form) {
      this.isEnd=false
      this.form = form;
      this.form.beginTime = form.cartime[0];
      this.form.endTime = form.cartime[1];
      this.pageIndex = 1;
      this.getList();
    },
    carimgShow(data) {
      this.$store.commit("boxDetail", {
        carList: data,
        showCard: ["过车信息", "数据信息"],
        title: "详情",
      });
    },
    getList(from) {
      if (from !== "add") this.imageList = [];
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      this.form.deviceType = 1;
      this.$http
        .POST_motorvehiclePage(this.form)
        .then((response) => {
          this.loading = false;
          if(response.data&&response.data.length){
          response.data.forEach((item, index) => {
            this.imageList.push(
              Object.assign({}, item, {
                img: item.thumbnailUrl || "../../static/img/img_error2.png",
                largeImg: item.storageUrl1,
                cartime: item.passingTimeFormat,
                tollgate: item.tollgateName,
                plateNumber: item.plateNo,
                plateColor: item.plateColor,
              })
            );
          });
          console.log(this.imageList);
          this.refreshKey = new Date().getTime();
          }else{
            this.$message("数据已请求完")
            this.isEnd=true
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    scroll(e) {
      // console.log(e.target.scrollTop);
      const bottomHeight =
        e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
      if (bottomHeight < 300&&!this.isEnd) {
        this.loading = true;
        if (this.setTimer) clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          this.pageIndex += 1;
          this.getList("add");
        }, 500);
      }
    },
  },
  mounted() {
    document.querySelector(".index-main").addEventListener("scroll", this.scroll);
  },
  created() {
    this.getList();
  },
  destroyed() {
    document.querySelector(".index-main").removeEventListener("scroll", this.scroll);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/search/kksj.vue